module.exports = __webpack_public_path__ + "static/media/admin_add-user.d18e6497.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/admin_add-user.md
// module id = 1081
// module chunks = 0